module.exports = __webpack_public_path__ + "img/e039f14ea6218b554ab633273aa92c95-check_mark.png";